export const SECURE_BROWSER_ERROR = 'SECURE_BROWSER_ERROR';
export const VERIFIED_ACCESS_KIOSK_ERROR = 'VERIFIED_ACCESS_KIOSK_ERROR';

export const setSecureBrowserError = error => ({
    type: SECURE_BROWSER_ERROR,
    error,
});

export const clearSecureBrowserError = () => ({
    type: SECURE_BROWSER_ERROR,
    error: null,
});

export const setVerifiedAccessKioskError = error => ({
    type: VERIFIED_ACCESS_KIOSK_ERROR,
    error,
});

export const clearVerifiedAccessKioskError = () => ({
    type: VERIFIED_ACCESS_KIOSK_ERROR,
    error: null,
});
